import { isMobile } from './common';

export function handleToggleMobileTopMenu() {
  $('.mobile-menu-toggler').click(function () {
    $('.mobile-menu-toggler').toggleClass('mobile-menu-toggler-active');
    const menuOpened = $('body').hasClass('mobile-top-menu-opened');

    if (menuOpened) {
      closeSideNavMenu();
    } else {
      openSideNavMenu();
    }
  });

  $(window).resize(function () {
    const menuOpened = $('body').hasClass('mobile-top-menu-opened');
    if (!isMobile() && menuOpened) {
      closeSideNavMenu();
    }
  });
}

export function handleToggleShowSubMenu() {
  $('.nav-menu')
    .find('.nav-item')
    .click(function () {
      const activeIndex = $('.nav-menu').find('.nav-item.active').data('index');
      const index = $(this).data('index');
      $(this).removeClass('active');

      if (index !== activeIndex) {
        $('.nav-menu').find('.nav-item').removeClass('active');
        $(this).addClass('active');
      }
    });
}

function doToggle(targets, classes) {
  // First, remove body closer click
  var bod = document.getElementsByTagName('body')[0];
  bod.dataset.togglerAttached = false;
  bod.onclick = null;
  // Loop through targets and toggle all classes on each
  for (let n = 0; n < targets.length; n++) {
    for (let x = 0; x < classes.length; x++) {
      targets[n].classList.toggle(classes[x]);
    }
  }
}

export function handleToggle() {
  var els = document.querySelectorAll('.toggle');
  for (let i = 0; i < els.length; i++) {
    var el = els[i];
    var classes = el.dataset.toggle ? el.dataset.toggle.split(' ') : ['open', 'closed'];
    var targets = el.dataset.target ? document.querySelectorAll(el.dataset.target) : [el];
    el.onclick = function() {
      // First do the toggle
      doToggle(targets, classes);

      // Then, if it's an opener, add a click handler to the body to toggle again to close
      if (el.dataset.toggleType == 'opener') {
        var bod = document.getElementsByTagName('body')[0];
        bod.dataset.togglerAttached = true;
        // Adding a timeout before adding onclick so it doesn't get triggered right away
        setTimeout(function() {
          bod.onclick = function(){doToggle(targets, classes)}
          // Don't register clicks from target element
          targets[0].onclick = function(e){e.stopPropagation();}
        }, 200);
      }
    }
  }
}

function closeSideNavMenu() {
  $('.wrap, footer').show().animate({ transform: 'translateX(0)' }, 500);
  $('body').removeClass('mobile-top-menu-opened');
  $('.primary-mobile-menu').removeClass('opened');
}

function openSideNavMenu() {
  $('body').addClass('mobile-top-menu-opened');
  $('.primary-mobile-menu').addClass('opened');
  $('.wrap, footer').show().animate({ transform: 'translateX(0)' }, 500);
  $('body').removeClass('mobile-top-header-opened');
  $('.top-header-mobile').removeClass('opened');
}



// WEBPACK FOOTER //
// ./scripts/func/menu.js